import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { renderIndicator } from 'components/AutoCarousel/customize';
import { CarouselContainer } from 'components/AutoCarousel/styles';

const settings = {
  infiniteLoop: true,
  autoPlay: true,
  showArrows: false,
  showThumbs: false,
  showStatus: false,
  renderIndicator,
  interval: 5000,
  stopOnHover: true,
};

const AutoCarousel: React.FC<{ children: React.ReactChild[] }> = ({
  children,
}) => {
  return (
    <CarouselContainer>
      <Carousel {...settings} showIndicators={true} className="direction">
        {children}
      </Carousel>
    </CarouselContainer>
  );
};

export default AutoCarousel;
